module.exports = __webpack_public_path__ + "img/2953960.e1282f35.png";